/*
 * @Author: qiangmin
 * @Date: 2021-05-10 17:56:12
 * @LastEditTime: 2021-05-10 14:21:28
 * @LastEditors: qiangmin
 * @Description: In User Settings Edit
 * @FilePath: \zz-platform-pages\src\skeleton\index.js
 */

const historyParse = location.href.split('?')
const historyRoute = historyParse && historyParse[0]
const skeletons = [
  {
    route: /\/zzNearbyPerson\/index/,
    component: () => import(/* webpackPrefetch: true */ './index.css')
  },
  {
    route: /\/publishMoreParameter/,
    component: () => import(/* webpackPrefetch: true */ './publishMoreParameter.css')
  }
]

if (historyRoute) {
  for (let i = 0; i < skeletons.length; i++) {
    if (skeletons[i].route.test(historyRoute)) {
      skeletons[i].component()
      break
    }
  }
}
